<script>
import Creative from './edit/Creative'
import Settings from './edit/Settings'
import { mapGetters } from 'vuex'
import ItemEdit from '../../mixins/edit/ItemEdit'

export default {
    name: 'landing-page-edit',
    components: {[Creative.name]: Creative,[Settings.name]: Settings,},
    mixins: [ItemEdit],
    computed:
    {
        ...mapGetters({
            dirty: 'landingPageFormIsDirty',
        }),
        isCreativeValid()
        {
            if (this.item && this.item.name && this.item.layouts[0] && this.item.layouts[0].id && this.item.color && this.item.headline
            && this.item.excerpt && this.item.label_signup && this.item.desktop_images[0] &&
            this.item.desktop_images[0].id && this.item.mobile_images[0] && this.item.mobile_images[0].id) {
                return true
            }
            return false
        },
        isSettingsValid()
        {
            if (this.item && this.item.url && this.item.meta.description && 
            this.item.meta.title && this.item.meta.keywords){
                return true
            }
            return false
        },
    },
    data()
    {
        return {
            action:
            {
                fetch: 'landingPageFetchById',
                update: 'landingPageUpdate',
                redirect: 'landingPageRedirectTo'
            }
        }
    },
}
</script>

<template lang="html">
    <div class="create-offer secondary-container container">
        <confirm-modal withRedirect ref="confirmModal" type="landingPageFormDirty"></confirm-modal>
        <simple-panel heading v-if="item">
            <div slot="heading" class="font-weight-bold">
                Signup Page Builder
            </div>
            <div class="">
                <div class="mb-3 row">
                    <div class="col-2 text-right pt-1 font-weight-bold">
                        Channel
                    </div>
                    <div class="col-10 font-weight-bold text-h2">
                        <template v-if="item.client && item.client.name && !changeClient">
                            <div>
                                {{ item.client.name }} <br>
                                <span class="cp text-blue font-size-base font-weight-normal" @click="changeClient=!changeClient">
                                    Change
                                </span>
                            </div>
                        </template>
                        <custom-multiselect
                        v-if="changeClient"
                        labelClasses="font-weight-bold text-right pr-3"
                        :options="clients.data"
                        searchable
                        placeholder="Select channel"
                        modelLabel="name"
                        @selected="selectClient">
                        </custom-multiselect>
                    </div>
                </div>

                <div class="mb-3 row">
                    <div class="col-2 text-right font-weight-bold" :class="{'pt-1': isChange}">
                        Signup Page Name
                    </div>
                    <div class="col-10">
                        <div v-if="!isChange">
                            <p class="mb-0">
                                <template v-if="item.name">
                                    <span>
                                    {{ item.name }}
                                    </span>
                                </template>
                            </p>
                            <span class="cp text-blue" @click="isChange=!isChange">
                                Change
                            </span>
                        </div>
                        <div  v-else class="f-10">
                            <div class="row">
                                <div class="col-6">
                                    <simple-input
                                    type="text"
                                    v-model="item.name"
                                    placeholder="Type a name"
                                    noRadius
                                    @enter="saveName"
                                    ></simple-input>
                                </div>
                                <div class="col-6">
                                    <custom-button classes="blue text-white text-uppercase xs" text="Save" @buttonClick="saveName"></custom-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-2 text-right font-weight-bold">
                        ID
                    </div>
                    <div class="col-10">
                        #{{ item.page_id }}
                    </div>
                </div>
            </div>
        </simple-panel>
        <panel-wrapper class="mb-2" isProgression v-if="item" routerName="offer-edit" :slug="page" :menu="menu" @switched="saveAll">
            <div slot="panel-wrapper-content">
                <div v-if="page=='creative'">
                    <create-landing-page-creative @saved="validation" :item="item"></create-landing-page-creative>
                </div>

                <div v-if="page=='settings'">
                    <create-landing-page-settings @saved="validation" :item="item"></create-landing-page-settings>
                </div>
            </div>
        </panel-wrapper>

        <div class="text-right text-placeholder-color" v-if="item">
            Last modified
            <template v-if="item.updated_at">
                <template v-if=" $moment.utc(item.updated_at, 'YYYY-MM-DD HH:mm:ss').diff($moment(), 'days') > 0" >
                    {{ item.updated_at | toDate }}
                </template>
                <template v-else>
                    {{ $moment.utc(item.updated_at, 'YYYY-MM-DD HH:mm:ss').fromNow() }}
                </template>
            </template>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/pages/landingpages/LandingPage.vue